import React from 'react';

import { Buttonset } from './Buttonset.styled';

export default ({ children, className, align = 'left' }) => (
  <Buttonset className={`buttonset ${className}`} align={align}>
    {children}
  </Buttonset>
);
